import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MUNILY_TITLE_PREVIEW_DEFAULTS, MunilyTitlePreviewSize } from './title-preview.types';

@Component({
  selector: 'common-title-preview',
  templateUrl: './title-preview.component.html',
  styleUrls: ['./title-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitlePreviewComponent {
  @Input() value: string = MUNILY_TITLE_PREVIEW_DEFAULTS.value;
  @Input() showEditIcon: boolean = MUNILY_TITLE_PREVIEW_DEFAULTS.showEditIcon;
  @Input() size: MunilyTitlePreviewSize = MUNILY_TITLE_PREVIEW_DEFAULTS.size;

  @Output() edit = new EventEmitter<void>();

  onEdit(): void {
    this.edit.emit();
  }
}
